import { useQuery } from "@tanstack/react-query";
import { reportService } from "../../services/reports";
import { IndianRupee, TrendingUp, Clock } from "lucide-react";

const RevenueChart = () => {
  const { data } = useQuery({
    queryKey: ["revenue-report"],
    queryFn: reportService.getRevenueReport,
  });

  const total = data?.total || 0;
  const paid = data?.paid || 0;
  const pending = total - paid;
  const paidPercent = total > 0 ? (paid / total) * 100 : 0;

  return (
    <div className="bg-white rounded-xl shadow-sm border border-gray-100 p-5">
      <h3 className="text-base font-semibold text-gray-900 mb-5">Revenue Overview</h3>
      <div className="grid grid-cols-3 gap-4 mb-6">
        <div className="text-center p-3 bg-blue-50 rounded-xl">
          <IndianRupee className="w-5 h-5 text-blue-600 mx-auto mb-1" />
          <p className="text-xl font-bold text-gray-900">₹{total.toLocaleString()}</p>
          <p className="text-xs text-gray-500">Total Revenue</p>
        </div>
        <div className="text-center p-3 bg-emerald-50 rounded-xl">
          <TrendingUp className="w-5 h-5 text-emerald-600 mx-auto mb-1" />
          <p className="text-xl font-bold text-gray-900">₹{paid.toLocaleString()}</p>
          <p className="text-xs text-gray-500">Collected</p>
        </div>
        <div className="text-center p-3 bg-amber-50 rounded-xl">
          <Clock className="w-5 h-5 text-amber-600 mx-auto mb-1" />
          <p className="text-xl font-bold text-gray-900">₹{pending.toLocaleString()}</p>
          <p className="text-xs text-gray-500">Pending</p>
        </div>
      </div>
      <div>
        <div className="flex items-center justify-between text-sm text-gray-600 mb-2">
          <span>Collection Progress</span>
          <span className="font-medium">{paidPercent.toFixed(1)}%</span>
        </div>
        <div className="w-full bg-gray-200 rounded-full h-3">
          <div
            className="h-3 rounded-full bg-gradient-to-r from-blue-500 to-emerald-500 transition-all duration-500"
            style={{ width: `${paidPercent}%` }}
          />
        </div>
      </div>
    </div>
  );
};

export default RevenueChart;
